import { render, staticRenderFns } from "./radio-adopt.vue?vue&type=template&id=3553e514&"
import script from "./radio-adopt.vue?vue&type=script&lang=js&"
export * from "./radio-adopt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports